export enum MailboxSendToggleState {
    CLASSIC = 'classic',
    NEW = 'new'
}

export const MAILBOXSEND_FORM_NAME = 'MAILBOXSEND';
export const MAILBOXSEND_TOGGLE_KEY = 'mailboxsend-toggle-state';
export const MAILBOXSEND_FEEDBACK_KEY = 'mailboxsend-feedback-reason';
